import axios from "axios";
import { toast } from "react-toastify";

export const baseURL =
  process.env.REACT_APP_ENV === "development"
    ? process.env.REACT_APP_API_DEV_URL
    : process.env.REACT_APP_API_URL;


export const axiosConfig = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: false,
  // timeout: 10000,
});

const axiosToken = axiosConfig;

// ✅ Intercepteur de requête : injecter le token
axiosToken.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Motifs renvoyés par l'API quand la session n'est plus valable :
// compte bloqué ou supprimé (voir auth.middleware.ts côté API)
const SESSION_REVOKED_REASONS = ["ACCOUNT_DISABLED", "ACCOUNT_NOT_FOUND"];
export const SESSION_MESSAGE_KEY = "sessionMessage";
let isRedirecting = false;

// ✅ Intercepteur de réponse : gérer les erreurs d'authentification
axiosToken.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("Erreur lors de la requête. Erreur: ", error);

    const data = error?.response?.data;
    if (SESSION_REVOKED_REASONS.includes(data?.reason) && !isRedirecting) {
      isRedirecting = true;
      localStorage.removeItem("authToken");
      try {
        sessionStorage.setItem(SESSION_MESSAGE_KEY, data.error);
      } catch (e) {
        // stockage indisponible : la redirection suffit
      }
      if (window.location.pathname !== "/login") {
        window.location.assign("/login");
      } else {
        // Déjà sur la page de connexion : on affiche le motif tout de suite
        sessionStorage.removeItem(SESSION_MESSAGE_KEY);
        toast.error(data.error, { position: "top-center" });
        isRedirecting = false;
      }
    }

    return Promise.reject(error);
  }
);

export default axiosToken;
